var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnStrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26903 2.28682L4.96242 1.08627C5.00203 1.05751 5.0466 1.03594 5.09116 1.02876C5.13077 1.01438 5.17533 1 5.21495 1L7.88872 1C7.94319 1 7.99765 1.01438 8.04222 1.05032C8.07193 1.05751 8.10163 1.07908 8.13134 1.09346L9.75046 2.23649C10.7655 2.76128 11.4785 3.57363 11.4785 4.73105C11.4785 6.91647 8.92853 7.90854 6.55679 7.90854C4.19 7.90854 1.64001 6.90929 1.64001 4.73105C1.64001 3.61676 2.3035 2.81161 3.26903 2.28682ZM6.55679 6.71429C8.73542 6.71429 9.92872 5.04736 10.0129 4.75261C10.003 4.73105 9.99308 4.70948 9.97823 4.68791L7.91348 4.31409L5.22485 4.3069C5.20999 4.31409 5.19019 4.32128 5.17534 4.32128L3.13534 4.68791C3.13039 4.70229 3.11554 4.71667 3.11059 4.72386C3.24427 5.09049 4.42767 6.71429 6.55679 6.71429Z",
    stroke: "#323335",
    strokeWidth: 0.53
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStrap);
export default __webpack_public_path__ + "static/media/icn_strap.675c8f52.svg";
export { ForwardRef as ReactComponent };